export default "__VITE_ASSET__5b68227f__"